// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"b5c64c0b","578":"7cbdbbd7","977":"459ae33c"}[chunkId] + ".chunk.js";
};